import React from 'react';
import PropTypes from 'prop-types';

const LandIcon = ({ dashArray, dashOffset, opacity, showStar }) => {
  return (
    <svg
      width="192"
      height="192"
      viewBox="0 0 192 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_7014_191887)">
        <circle cx="96" cy="92" r="80" fill="white" />
        <circle
          cx="96"
          cy="92"
          r="77"
          stroke={showStar ? '#E4E5E7' : 'white'}
          strokeWidth="6"
        />
      </g>
      <circle
        className="progressBar"
        cx="96"
        cy="92"
        r="77"
        fill="transparent"
        strokeWidth="6"
        stroke="#FFC50A"
        strokeDasharray={dashArray || ''}
        strokeDashoffset={dashOffset || ''}
        strokeLinecap="butt"
      />
      <circle cx="96" cy="92" r="65" fill="#E2F7FF" />
      {showStar && <circle cx="96" cy="19" r="15" fill="#FFC50A" />}
      <path
        d="M94.064 16.621L95.4667 13.7787C95.6501 13.4071 96.18 13.4071 96.3634 13.7787L97.7661 16.621L100.902 17.0762C101.312 17.1357 101.476 17.6397 101.179 17.929L98.9103 20.1415L99.4459 23.2655C99.5159 23.674 99.0871 23.9855 98.7203 23.7925L95.9151 22.317L93.1098 23.7925C92.743 23.9855 92.3142 23.674 92.3842 23.2655L92.9198 20.1415L90.651 17.929C90.3543 17.6397 90.5181 17.1357 90.9282 17.0762L94.064 16.621Z"
        fill="white"
      />
      <g opacity={opacity}>
        <path
          d="M59.1615 132.222C58.8016 130.056 59.0571 127.834 59.8997 125.804C60.7517 123.688 62.1668 121.84 63.9947 120.457C65.8225 119.073 67.9947 118.206 70.2805 117.947C73.2657 117.645 76.2615 118.412 78.7246 120.109C81.1877 121.806 82.9551 124.321 83.7063 127.197C84.6573 126.841 85.6651 126.655 86.6821 126.649C88.2976 126.654 89.8753 127.134 91.2145 128.029C92.5536 128.923 93.5937 130.192 94.2024 131.674C94.258 131.822 94.2768 131.981 94.2571 132.138C94.2375 132.295 94.1799 132.444 94.0893 132.574C93.9988 132.704 93.8779 132.811 93.737 132.885C93.596 132.958 93.4391 132.998 93.2797 132.999H60.1073C59.8833 132.997 59.6666 132.919 59.4942 132.778C59.3218 132.636 59.2042 132.44 59.1615 132.222V132.222Z"
          fill="#007E86"
        />
        <path
          d="M104.237 80.4922H92.4258V132.27H104.237V80.4922Z"
          fill="#352269"
        />
        <path
          d="M115.335 101.926L111.322 97.9531L98.3381 110.809L102.351 114.782L115.335 101.926Z"
          fill="#352269"
        />
        <path
          d="M141.792 131.857C142.277 128.771 141.902 125.612 140.708 122.721C139.505 119.679 137.493 117.016 134.886 115.013C132.279 113.011 129.173 111.744 125.898 111.347C121.603 110.911 117.292 112.015 113.75 114.459C110.207 116.902 107.666 120.523 106.59 124.663C105.279 124.166 103.888 123.911 102.484 123.909C100.165 123.891 97.894 124.566 95.9681 125.845C94.0422 127.125 92.5505 128.949 91.6879 131.081C91.6063 131.293 91.5777 131.522 91.6044 131.748C91.6312 131.974 91.7125 132.19 91.8415 132.378C91.9705 132.567 92.1433 132.721 92.3455 132.829C92.5476 132.937 92.7731 132.996 93.0028 132.999H140.408C140.737 132.999 141.056 132.885 141.309 132.676C141.562 132.468 141.733 132.178 141.792 131.857V131.857Z"
          fill="#00B0AC"
        />
        <path
          d="M129.036 94.3075C131.256 94.3387 133.4 93.5074 135.009 91.9916C136.617 90.4759 137.562 88.3965 137.64 86.1993V86.1993C137.64 82.7405 136.252 79.4233 133.782 76.9776C131.312 74.5318 127.961 73.1578 124.468 73.1578H124.307C123.593 66.8313 120.549 60.9872 115.757 56.743C110.965 52.4988 104.761 50.1523 98.3316 50.1523C91.902 50.1523 85.6981 52.4988 80.9061 56.743C76.114 60.9872 73.0702 66.8313 72.3566 73.1578H72.1951C68.7194 73.1576 65.384 74.5152 62.9134 76.9357C60.4427 79.3562 59.0365 82.644 59 86.0851V86.0851C59.0485 88.3064 59.9833 90.4183 61.6 91.9591C63.2167 93.4999 65.3839 94.3442 67.6276 94.3075H129.036Z"
          fill="#007E86"
        />
        <path
          d="M113.626 102.576C115.231 102.576 116.532 101.288 116.532 99.6981C116.532 98.1088 115.231 96.8203 113.626 96.8203C112.021 96.8203 110.719 98.1088 110.719 99.6981C110.719 101.288 112.021 102.576 113.626 102.576Z"
          fill="#8D83BE"
        />
        <path
          d="M137.64 86.2006C137.64 82.7418 136.252 79.4246 133.782 76.9789C131.312 74.5331 127.961 73.1591 124.468 73.1591H124.306C123.787 68.3747 121.935 63.8272 118.958 60.0241C115.98 56.221 111.994 53.3118 107.443 51.6211C102.902 53.2952 98.9191 56.1842 95.9378 59.9666C92.9565 63.7491 91.0939 68.2765 90.5574 73.0449H90.3728C86.8773 73.0449 83.5245 74.4182 81.0506 76.8633C78.5767 79.3084 77.1838 82.6255 77.1777 86.0864V86.0864C77.2618 88.2857 78.2115 90.3651 79.8237 91.8802C81.4359 93.3953 83.5827 94.226 85.8053 94.1946H129.035C131.237 94.2268 133.364 93.4111 134.97 91.9197C136.575 90.4282 137.532 88.3777 137.64 86.2006V86.2006Z"
          fill="#00B0AC"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_7014_191887"
          x="0"
          y="0"
          width="192"
          height="192"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7014_191887"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7014_191887"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_7014_191887">
          <rect
            width="83"
            height="83"
            fill="white"
            transform="translate(57 50)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

LandIcon.propTypes = {
  percentage: PropTypes.string,
};

LandIcon.defaultProps = {
  percentage: '0%',
};

export default LandIcon;
